var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.logo === 'schuette')?[_c('logo-schuette')]:_vm._e(),_vm._v(" "),(_vm.logo === 'rzaska')?[_c('logo-rzaska')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }